import React from 'react';
import Logo from './Logo';
import QuickLinks from './QuickLinks';
import ContactInfo from './ContactInfo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white h-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 h-full flex flex-col justify-between">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-5">
          <div>
            <Logo />
            <p className="mt-4 text-gray-400">
              Connecting students with expert teachers for personalized online learning experiences.
            </p>
          </div>
          <QuickLinks />
          <ContactInfo />
        </div>
        
        <div className="pt-4 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} AcademiaHub. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
